module.exports = __webpack_public_path__ + "src/assets/img/firstbandera-fill.9581c80a.jpg";